// Theme color configuration matching Nuxt source
export const THEME_COLORS = [
  { name: 'default', value: 'oklch(0.205 0 0)' },
  { name: 'blue', value: 'oklch(0.561 0.214 259.815)' },
  { name: 'green', value: 'oklch(0.536 0.149 149.579)' },
  { name: 'red', value: 'oklch(0.581 0.235 25.331)' },
  { name: 'rose', value: 'oklch(0.582 0.232 16.439)' },
  { name: 'violet', value: 'oklch(0.581 0.25 292.717)' },
  { name: 'orange', value: 'oklch(0.567 0.155 47.604)' },
  { name: 'yellow', value: 'oklch(0.795 0.184 86.047)' },
  { name: 'teal', value: 'oklch(0.54 0.095 184.704)' },
] as const;

export const THEME_TYPES = ['default', 'scaled', 'mono'] as const;

export const SIDEBAR_VARIANTS = ['default', 'floating', 'inset'] as const;

export type ThemeColor = (typeof THEME_COLORS)[number]['name'];
export type ThemeType = (typeof THEME_TYPES)[number];
export type SidebarVariant = (typeof SIDEBAR_VARIANTS)[number];

// Color tokens for style guide display
export const COLOR_TOKENS = [
  { name: 'background', var: '--background', desc: 'Page background', preview: 'bg-background' },
  { name: 'foreground', var: '--foreground', desc: 'Text color', preview: 'bg-foreground' },
  { name: 'primary', var: '--primary', desc: 'Primary brand color', preview: 'bg-primary' },
  { name: 'primary-foreground', var: '--primary-foreground', desc: 'Text on primary', preview: 'bg-primary-foreground' },
  { name: 'secondary', var: '--secondary', desc: 'Secondary color', preview: 'bg-secondary' },
  { name: 'muted', var: '--muted', desc: 'Muted background', preview: 'bg-muted' },
  { name: 'muted-foreground', var: '--muted-foreground', desc: 'Muted text', preview: 'bg-muted-foreground' },
  { name: 'accent', var: '--accent', desc: 'Accent highlights', preview: 'bg-accent' },
  { name: 'destructive', var: '--destructive', desc: 'Error/danger', preview: 'bg-destructive' },
  { name: 'border', var: '--border', desc: 'Border color', preview: 'bg-border' },
  { name: 'ring', var: '--ring', desc: 'Focus ring', preview: 'bg-ring' },
] as const;
